@if (isLoading) {
  <div class="spinner-overlay">
    <mat-spinner></mat-spinner>
  </div>
}

<h1 class="title">Upscaling Rock Models</h1>

@if (!isLoading && rockModelData) {
<mat-card class="rock-models-card">
  <div class="rock-models-layout">
    <div class="left-panel">
      <div class="file-info-card">
        <div class="info-row">
          <span class="info-label">Rock File:</span>
          <span class="info-value">{{ fileName | removeExtension }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Size:</span>
          <span class="info-value">{{ getSizeString() }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Phases count:</span>
          <span class="info-value">{{ rockModelData.phasesCount }}</span>
        </div>
      </div>

      <div class="image-preview-card">
        <div class="image-header">Upscaling Segmented Rock Image</div>
        <div class="image-and-phases-row">
          <div class="image-container">
            @if (thumbnailUrl) {
              <img [src]="thumbnailUrl" alt="Rock image thumbnail" class="rock-thumbnail" />
            } @else {
              <div class="placeholder-image">
                <mat-icon>image</mat-icon>
                <p>No preview available</p>
              </div>
            }
          </div>
          <div class="view-phases-panel">
          @if (phases.length) {
            <div class="view-phases-table-container">
              <table class="view-phases-table">
                <thead>
                  <tr>
                    <th>Phase</th>
                    <th>Label</th>
                    <th>Fraction</th>
                  </tr>
                </thead>
                <tbody>
                  @for (phase of phases; track phase.phase) {
                    <tr>
                      <td>
                        <div class="phase-indicator" [style.background-color]="phase.color || 'rgb(128, 128, 128)'"></div>
                      </td>
                      <td>{{ phase.label }}</td>
                      <td>{{ phase.fraction | number : '1.3-3' }}</td>
                    </tr>
                  }
                </tbody>
                <tfoot>
                  <tr class="total-row">
                    <td colspan="2">Total</td>
                    <td>{{ totalFraction | number : '1.3-3' }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          } @else {
            <div class="view-phases-empty">Phase data not available</div>
          }
        </div>
        </div>
      </div>
    </div>

    <div class="right-panel">
      <div class="models-table-container">
        <h2 class="table-title">Rock Models</h2>

        <div class="table-wrapper">
          <table class="models-table mat-elevation-z2">
            <thead>
              <tr>
                <th>Name</th>
                <th>Total<br/>porosity</th>
                <th>Permeability</th>
                <th>Formation<br/>Factor</th>
              </tr>
            </thead>
            <tbody>
              @if (!rockModelData.rockModels.length) {
                <tr>
                  <td class="empty-state" colspan="4">
                    No rock models yet. Click “Create Rock Model” to create one.
                  </td>
                </tr>
              } @else {
                @for (model of rockModelData.rockModels; track model.id) {
                  <tr
                    (click)="onRowClick(model)"
                    [class.selected]="model.id === selectedModel?.id"
                  >
                    <td>{{ model.name }}</td>
                    <td>{{ model.totalPorosity | number : '1.1-2' }}</td>
                    <td>{{ model.permeability ? 'Yes' : 'No' }}</td>
                    <td>{{ model.formationFactor ? 'Yes' : 'No' }}</td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      </div>

      <div class="actions-row">
        <button class="btn btn-primary" (click)="newRockModel()">
          Create Rock Model
        </button>
        <button
          class="btn btn-secondary"
          [disabled]="!selectedModel"
          (click)="previewRockModel()"
        >
          View Rock Model
        </button>
        <button
          class="btn btn-secondary"
          [disabled]="!selectedModel"
          (click)="duplicateRockModel()"
        >
          Clone Rock Model
        </button>
        <button
          class="btn btn-warn"
          [disabled]="!selectedModel"
          (click)="deleteRockModel()"
        >
          Delete Rock Model
        </button>
      </div>
    </div>
  </div>
</mat-card>
}
